export const HTTP_METHODS: {
	[key: string]: 'POST' | 'PUT' | 'GET' | 'DELETE' | 'OPTIONS';
} = {
	POST: 'POST',
	PUT: 'PUT',
	GET: 'GET',
	DELETE: 'DELETE',
	OPTIONS: 'OPTIONS',
};
